import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

// shadcn/ui's idiomatic class-name helper. Combines clsx's conditional
// semantics with tailwind-merge's last-write-wins rules so downstream
// overrides on primitives behave intuitively.
export function cn(...inputs: readonly ClassValue[]): string {
  return twMerge(clsx(inputs));
}
